import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const highlights = ["Certified Florida Keys inspection specialists", "Comprehensive wind mitigation & 4-point reports", "Detailed digital reports delivered within 24 hours", "Expert knowledge of coastal building codes", "Locally owned and operated in the Keys"];
export default function ResidentialExperience() {
  return <section data-section-id="242774" id="overview" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          <div className="flex flex-col justify-center">
            <h3 className="font-default text-2xl md:text-3xl font-bold text-foreground mb-6">
              Your Trusted Florida Keys Inspectors
            </h3>
            
            <ul className="space-y-4 mb-8">
              {highlights.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="size-6 text-primary shrink-0 mt-0.5" />
                  <span className="text-lg text-muted-foreground font-default leading-relaxed">
                    {item}
                  </span>
                </li>)}
            </ul>
            
            <div>
              <Button asChild size="lg" className="text-base px-8 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-md">
                <Link to="https://trusted-fl.com/#schedule-your-inspection">Schedule Your Inspection</Link>
              </Button>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden shadow-xl border border-border/50">
            <AspectRatio ratio={4 / 3}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/florida_keys_coastal_home.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/florida_keys_coastal_home.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/florida_keys_coastal_home.png-wvc-sizes" alt="Coastal home in the Florida Keys" className="object-cover w-full h-full" loading="lazy" />
            </AspectRatio>
          </div>

        </div>
      </div>
    </section>;
}